var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEcabinet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-icons-V2",
    transform: "translate(-61.000000, -523.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_ecabinet",
    transform: "translate(61.000000, 523.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.91666667,6.6 C2.42083333,6.6 2.83333333,7.005 2.83333333,7.5 L2.83333333,7.5 L2.83333333,18.3 C2.83333333,18.795 3.24583333,19.2 3.75,19.2 L3.75,19.2 L18.4166667,19.2 C18.9208333,19.2 19.3333333,19.605 19.3333333,20.1 C19.3333333,20.595 18.9208333,21 18.4166667,21 L18.4166667,21 L2.83333333,21 C1.825,21 1,20.19 1,19.2 L1,19.2 L1.00916667,11.1 L1,11.1 L1,7.5 C1,7.005 1.4125,6.6 1.91666667,6.6 Z M11.8346113,3 C12.0689169,3 12.2939859,3.09137516 12.4619818,3.25470457 L12.4619818,3.25470457 L14,4.75 L21.2,4.75 C22.19,4.75 23,5.5375 23,6.5 L23,6.5 L23,15.25 C23,16.2125 22.19,17 21.2,17 L21.2,17 L6.8,17 C5.81,17 5,16.2125 5,15.25 L5,15.25 L5.009,4.75 C5.009,3.7875 5.81,3 6.8,3 L6.8,3 Z M11.0876113,4.75 L7.7,4.75 C7.20294373,4.75 6.8,5.15294373 6.8,5.65 L6.8,5.65 L6.8,14.35 C6.8,14.8470563 7.20294373,15.25 7.7,15.25 L7.7,15.25 L20.3,15.25 C20.7970563,15.25 21.2,14.8470563 21.2,14.35 L21.2,14.35 L21.2,7.4 C21.2,6.90294373 20.7970563,6.5 20.3,6.5 L20.3,6.5 L13.6183887,6.5 C13.3840831,6.5 13.1590141,6.40862484 12.9910182,6.24529543 L12.9910182,6.24529543 L11.7149818,5.00470457 C11.5469859,4.84137516 11.3219169,4.75 11.0876113,4.75 L11.0876113,4.75 Z",
    id: "Combined-Shape",
    fill: "#616674"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEcabinet);
export default __webpack_public_path__ + "static/media/ic_ecabinet.2437fe7f2cdb7d53883b26ec9afec0e9.svg";
export { ForwardRef as ReactComponent };